import React, { useState } from 'react';
import { AddNewLead } from '../../../store/actions/new/leadDataAction';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ToastManager from '../../default/popup/alert/apiNotification';

const EntryList = ({ entries, onAdd, onChange, onRemove, entryType, placeholder }) => {
    return (
        <>
            {entries.map((entry, index) => (
                <div className="sng-content-repeater d-right-auto" key={index}>
                    <div className="sng-content">
                        <label>Type</label>
                        <input
                            type="text"
                            className="sett-form-input"
                            placeholder="Type"
                            value={entry.type || ''}
                            onChange={(e) => onChange(index, 'type', e.target.value)}
                        />
                    </div>
                    <div className="sng-content">
                        <label>{entryType}</label>
                        <input
                            type="text"
                            className="sett-form-input"
                            placeholder={placeholder}
                            value={entry.value || ''}
                            onChange={(e) => onChange(index, 'value', e.target.value)}
                        />
                    </div>
                    {entries.length > 1 && (
                        <button
                            type="button"
                            className="remove-btn"
                            onClick={() => onRemove(index)}
                        >
                            <i className="ri-subtract-fill"></i>
                        </button>
                    )}
                </div>
            ))}
            <div className="sng-content-repeater add-field-button">
                <button type="button" className="add-new-field" onClick={onAdd}>
                    <i className="ri-add-line"></i> Add
                </button>
            </div>
        </>
    );
};

const NewLeadForm = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [title, setTitle] = useState('');
    const [company, setCompany] = useState('');
    const [emailEntries, setEmailEntries] = useState([{ type: '', value: '' }]);
    const [phoneEntries, setPhoneEntries] = useState([{ type: '', value: '' }]);
    const [websiteEntries, setWebsiteEntries] = useState([{ type: '', value: '' }]);
    const [addressEntries, setAddressEntries] = useState([{ type: '', value: '' }]);
    const [notesEntries, setNotesEntries] = useState([{ type: '', value: '' }]);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const handleAddEntry = (type) => {
        const settersMap = {
            email: setEmailEntries,
            phone: setPhoneEntries,
            website: setWebsiteEntries,
            address: setAddressEntries,
            note: setNotesEntries,
        };

        settersMap[type]((prev) => [...prev, { type: '', value: '' }]);
    };

    const handleChange = (type, index, field, value) => {
        const settersMap = {
            email: setEmailEntries,
            phone: setPhoneEntries,
            website: setWebsiteEntries,
            address: setAddressEntries,
            note: setNotesEntries,
        };

        settersMap[type]((prevEntries) => {
            const newEntries = [...prevEntries];
            newEntries[index] = {
                ...newEntries[index],
                [field]: value
            };
            return newEntries;
        });
        // Clear errors when user starts typing
        if (errors[type]) {
            setErrors(prev => ({ ...prev, [type]: '' }));
        }
    };

    const handleRemove = (type, index) => {
        const settersMap = {
            email: setEmailEntries,
            phone: setPhoneEntries,
            website: setWebsiteEntries,
            address: setAddressEntries,
            note: setNotesEntries,
        };

        settersMap[type]((prevEntries) => {
            return prevEntries.filter((_, i) => i !== index);
        });

    };
    const validateForm = () => {
        const newErrors = {};

        if (!firstName.trim()) {
            newErrors.firstName = 'First name is required';
        }

        if (!lastName.trim()) {
            newErrors.lastName = 'Last name is required';
        }

        // Check if at least one email is provided
        // const hasValidEmail = emailEntries.some(entry => entry.value && entry.value.trim());
        // if (!hasValidEmail) {
        //     newErrors.email = 'At least one email is required';
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        // Format the additional info entries
        const formatEntries = (entries, type) => {
            return entries.map(entry => ({
                type,
                title: entry.type || type,
                value: entry.value
            })).filter(entry => entry.value);
        };

        // Combine all additional info entries
        const adiInfo = [
            ...formatEntries(phoneEntries, 'phone'),
            ...formatEntries(emailEntries, 'email'),
            ...formatEntries(websiteEntries, 'website'),
            ...formatEntries(addressEntries, 'address'),
            ...formatEntries(notesEntries, 'note')
        ];

        const formData = {
            firstName,
            lastName,
            title,
            company,
            adiInfo
        };
        // dispatch the action
        try {
            const response = await dispatch(AddNewLead(formData));
            if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                navigate(-1);
            } else {
                console.error('Failed to add new lead:', response);
            }
        } catch (error) {
            ToastManager.showError(1, error || 'Failed to add lead.');
        }


    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="settings-list-wrapper">
                <div class="connection-header settings-header">
                    <h3>New Lead</h3>
                </div>
                <div className="single-settings" id="basic-info">
                    <h5 className="setting-title">Basic info</h5>
                    <div className="setting-content">
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>First name</label>
                                <input
                                    className={`sett-form-input ${errors.firstName ? 'border-red-500' : ''}`}
                                    value={firstName}
                                    onChange={(e) => {
                                        setFirstName(e.target.value);
                                        if (errors.firstName) {
                                            setErrors(prev => ({ ...prev, firstName: '' }));
                                        }
                                    }}
                                    placeholder="e.g. John"
                                />
                                {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Last name</label>
                                <input
                                    className={`sett-form-input ${errors.lastName ? 'border-red-500' : ''}`}
                                    value={lastName}
                                    onChange={(e) => {
                                        setLastName(e.target.value);
                                        if (errors.lastName) {
                                            setErrors(prev => ({ ...prev, lastName: '' }));
                                        }
                                    }}
                                    placeholder="e.g. Doe"
                                />

                                {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Title</label>
                                <input
                                    type="text"
                                    className="sett-form-input"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    placeholder="Title"
                                />
                            </div>
                        </div>
                        <div className="sng-content-repeater">
                            <div className="sng-content">
                                <label>Company</label>
                                <input
                                    type="text"
                                    className="sett-form-input"
                                    value={company}
                                    onChange={(e) => setCompany(e.target.value)}
                                    placeholder="Cardiast"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="single-settings hide-lebel" id="email-section">
                    <h5 className="setting-title">Email</h5>
                    <div className={`setting-content ${errors.lastName ? 'mail-error' : ''}`}>
                        <EntryList
                            entries={emailEntries}
                            onAdd={() => handleAddEntry('email')}
                            onChange={(index, field, value) => handleChange('email', index, field, value)}
                            onRemove={(index) => handleRemove('email', index)}
                            entryType="Email"
                            placeholder="e.g. info@yourmail.com"
                        />
                        {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                    </div>
                </div>
                <div className="single-settings hide-lebel" id="phone-section">
                    <h5 className="setting-title">Phone</h5>
                    <div className="setting-content">
                        <EntryList
                            entries={phoneEntries}
                            onAdd={() => handleAddEntry('phone')}
                            onChange={(index, field, value) => handleChange('phone', index, field, value)}
                            onRemove={(index) => handleRemove('phone', index)}
                            entryType="Phone"
                            placeholder="e.g. 123-456-7890"
                        />
                    </div>
                </div>
                <div className="single-settings hide-lebel" id="website-section">
                    <h5 className="setting-title">Websites</h5>
                    <div className="setting-content">
                        <EntryList
                            entries={websiteEntries}
                            onAdd={() => handleAddEntry('website')}
                            onChange={(index, field, value) => handleChange('website', index, field, value)}
                            onRemove={(index) => handleRemove('website', index)}
                            entryType="Website"
                            placeholder="e.g. www.yourwebsite.com"
                        />
                    </div>
                </div>
                <div className="single-settings hide-lebel" id="address-section">
                    <h5 className="setting-title">Address</h5>
                    <div className="setting-content">
                        <EntryList
                            entries={addressEntries}
                            onAdd={() => handleAddEntry('address')}
                            onChange={(index, field, value) => handleChange('address', index, field, value)}
                            onRemove={(index) => handleRemove('address', index)}
                            entryType="Address"
                            placeholder="e.g. 123 Main St"
                        />
                    </div>
                </div>
                <div className="single-settings hide-lebel" id="notes-section">
                    <h5 className="setting-title">Notes</h5>
                    <div className="setting-content">
                        <EntryList
                            entries={notesEntries}
                            onAdd={() => handleAddEntry('note')}
                            onChange={(index, field, value) => handleChange('note', index, field, value)}
                            onRemove={(index) => handleRemove('note', index)}
                            entryType="Note"
                            placeholder="e.g. Important note"
                        />
                    </div>
                </div>
                <div className="button-wrapper form-error-wrapper">
                    {(errors.firstName || errors.lastName || errors.email) && <p className="text-red-500 text-sm mt-1">Please fill all the required fields.</p>}
                    <button type="submit" className="btn submit-btn bg-primary">Submit</button>
                </div>
            </div>
        </form>
    );
};

export default NewLeadForm;